import { render, staticRenderFns } from "./TenantRenewalStart.vue?vue&type=template&id=0122a4f4&"
import script from "./TenantRenewalStart.vue?vue&type=script&lang=js&"
export * from "./TenantRenewalStart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports